<template>
  <div class="tabs_content" v-show="$_loggedUser_action_allowed('billers')">
    <div>
      <section>
        <div class="left">
          <h2>{{ 'Plátce' | translate }}</h2>
        </div>
        <div class="right">
          <div class="field_left">
            <select-box id="vyberteplatce"
                        v-model="billerId"
                        :options="billerOptions"
                        :undefined-text="'Žádný' | translate"
                        :undefined-value="null"
                        :disabled="disabled"
                        @input="billerIdChange"
            >
              <translate class="translate">Vyberte plátce</translate>
            </select-box>
          </div>
          <div class="field" v-show="canShowBiller">
            <p class="info_text">
              <span v-translate>Příjmení:</span>
              <strong>{{ selectedBiller.surname }}</strong>
              <br />
              <span v-translate>Jméno:</span>
              <strong>{{ selectedBiller.firstname }}</strong>
              <br />
              <span v-translate>Typ subjektu:</span>
              <strong>{{ subjectTypeDisplayValue }}</strong>
              <br />
              <span v-translate>Vlastní ID:</span>
              <strong>{{ selectedBiller.id_remote }}</strong>
              <br />
              <span v-translate>Firma:</span>
              <strong>{{ selectedBiller.company_name }}</strong>
              <br />
              <span v-translate>IČ:</span>
              <strong>{{ selectedBiller.cin }}</strong>
              <br />
              <span v-translate>DIČ:</span>
              <strong>{{ selectedBiller.tin }}</strong>
              <br />
            </p>
            <p class="info_text">
              <span v-translate>E-mail:</span>
              <strong>{{ selectedBiller.email }}</strong>
              <br />
              <span v-translate>Telefon:</span>
              <strong>{{ selectedBiller.phone }}</strong>
              <br />
              <span v-translate>Ulice a č. p.:</span>
              <strong>{{ selectedBiller.address.street }}</strong>
              <br />
              <span v-translate>Město:</span>
              <strong>{{ selectedBiller.address.town }}</strong>
              <br />
              <span v-translate>PSČ:</span>
              <strong>{{ selectedBiller.address.postal_code }}</strong>
              <br />
              <span v-translate>Stát:</span>
              <strong>{{ selectedBiller.address.country }}</strong>
              <br />
            </p>
          </div>
          <p :class="['add_payer', { open: billerOpen }]"
             v-if="$_loggedUser_action_allowed('billers', 'create') && !disabled">
            <a @click.stop.prevent="toggleNewBiller" v-translate>Přidat nového plátce</a>
          </p>
        </div>
      </section>
      <section :class="['new_payer', { open: billerOpen }]">
        <div class="left">
          <h2>{{ 'Nový plátce' | translate }}</h2>
        </div>
        <biller-form
            :entity="newBiller"
            :isEditable="true"
            :ownId="ownId"
            @own-id-change="setOwnId"
            ref="billerformref"
        />
        <a
            class="btn btn_action btn_close"
            :title="'Zavřít' | translate"
            @click="toggleNewBiller"
            v-translate>Zavřít
        </a>
      </section>
    </div>
    <section class="buttons">
      <p>
        <router-link
            :to="{ name: moduleName }"
            class="btn btn_back btn_seznam"
            v-translate>Seznam
        </router-link>
        <input
            type="submit"
            :value="'Uložit plátce' | translate"
            class="btn"
            @click.prevent.stop="submitForm()"
            v-if="$_updateActionAllowed"
        />
      </p>
    </section>
  </div>
</template>

<script>
import SelectBox from "@/components/common/SelectBox"
import BillerForm from "@/components/views/billers/BillerForm"

import billers from "@/components/views/billers/mixins/billers"
import subscriberData from "@/components//mixins/subscriber-data"
import detailActions from "@/components/mixins/detail-actions"

export default {
  name: "SubscriberDetailBiller",
  components: {
    BillerForm,
    SelectBox
  },
  mixins: [detailActions, billers, subscriberData],
  data: function () {
    return {
      billers: [],
      selectedBiller: { address: {} },
      billerOpen: false,
      billerId: null,
      newBiller: {},
    }
  },
  props: {
    entity: Object,
  },
  created(SubscriberService, BillerService, OperatorService) {
    this.entityService = SubscriberService
    this.billerService = BillerService
    this.operatorService = OperatorService

    this.billerId = this.entity.id_biller || null
    this.newBiller.id_operator = this.entity.id_operator
    this.getBillers()
    this.getOperators()
  },
  computed: {
    disabled() {
      return this.billerOpen || !this.$_updateActionAllowed;
    },
    billerOptions() {
      return this.billers.map((biller) => ({ id: biller.id, text: `${biller.surname} ${biller.firstname}` }))
    },
    subjectTypeDisplayValue() {
      return this.selectedBiller.subject_type === 'person' ? this.$gettext('Fyzická osoba') : this.$gettext('Právnická osoba')
    },
    canShowBiller() {
      return Boolean(this.billerId) && this.$_loggedUser_action_allowed('billers', 'create');
    }
  },
  methods: {
    selectBiller() {
      if (!this.billerId) {
        return
      }
      this.selectedBiller = this.billers.filter(biller => biller.id === Number(this.billerId))[0];
    },
    getBillers() {
      this.entityService.getBillers(this.entity.id)
          .then((data) => {
            this.billers = data['billers']
            this.selectBiller()
          })
    },
    addBiller(redirect = false) {
      this.entityService.createBiller(
          this.entity.id,
          this.filterFormParams({ ...this.newBiller })
      )
          .then(() => {
            if (redirect === true) {
              this.redirect()
            } else {
              this.setSuccessMessage()
              this.billerOpen = false
              this.$emit('getEntity')
            }
          })
          .catch(function (error) {
            this.processErrorMessage(error)
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },
    updateSubscriberBiller(redirect = false) {
      this.entityService.updateEntity(this.entity.id, { 'id_biller': this.billerId })
          .then(() => {
            if (redirect === true) {
              this.redirect()
            } else {
              this.setSuccessMessage()
              this.$emit('getEntity')
            }
          })
          .catch(function (error) {
            this.setErrorMessage(error['error_message'])
          }.bind(this))
    },
    submitForm(redirect = false) {
      if (this.billerOpen) {
        this.addBiller(redirect)
      } else {
        this.updateSubscriberBiller(redirect)
      }
    },
    toggleNewBiller() {
      this.billerOpen = !this.billerOpen
    },
    billerIdChange() {
      const billerIdChanged = (Number(this.billerId) !== Number(this.entity.id_biller))
      if (billerIdChanged) {
        this.selectBiller()
      }
    }
  },
  watch: {
    'entity.id_biller'() {
      this.billerId = this.entity.id_biller
      this.getBillers()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/biller/Biller.vue